import React from 'react';
import { FaArrowLeft } from 'react-icons/fa';

interface LeavePodiumProps {
  onLeavePodium: () => void;
}

const LeavePodium: React.FC<LeavePodiumProps> = ({ onLeavePodium }) => {
  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        onLeavePodium();
      }}
      className="px-4 py-2 bg-orange-600 bg-opacity-80 text-white rounded-lg hover:bg-opacity-100 transition-all duration-200 font-semibold flex items-center gap-2 shadow-lg"
      title="Leave Podium"
    >
      <FaArrowLeft size={16} />
      Leave Podium
    </button>
  );
};

export default LeavePodium;

